export default __webpack_public_path__ + "static/media/eth-pink.0cffa891.svg";